import React from 'react';
import { useMutation } from 'react-query';
import { useRecoilState } from 'recoil';
import axios, { endPoints } from 'api/request';
import Select from 'pages/reference-implementation/components/select';
import { InputLabel } from 'pages/reference-implementation/components/input-label';
import { OrderPayload } from 'pages/reference-implementation/provisioning/RI003AWS/store';

const VpcName = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const vpcDetailsApi = useMutation((payload) => axios.post(`${endPoints.aws.lookups.vpcDetails}`, payload));

    React.useEffect(() => {
        if (vpcDetailsApi?.isSuccess) {
            const vpcs = vpcDetailsApi?.data?.data || [];
            if (!vpcs?.length) {
                setOptions([]);
                if (order?.vpcName) {
                    setOrder((prev) => ({ ...prev, vpcName: null, vpcId: null }));
                }
                return;
            }

            const vpcOptions = vpcs?.map((vpc) => ({
                label: vpc?.vpcName,
                value: vpc?.vpcName,
                data: vpc,
            }));
            setOptions(vpcOptions);

            if (order?.vpcName) return;

            const matchedVpc = order?.vpcId && vpcs.find((vpc) => vpc?.vpcId === order?.vpcId);
            const autoVpc = matchedVpc || (vpcOptions.length === 1 && vpcOptions[0]?.data);
            if (autoVpc) {
                setOrder((prev) => ({ ...prev, vpcName: autoVpc?.vpcName, vpcId: autoVpc?.vpcId }));
            }
        }
    }, [vpcDetailsApi?.isSuccess]);

    React.useEffect(() => {
        if (order?.sector && order?.department && order?.landingZoneDetails?.sharedNetworkAccountId && order?.landingZoneDetails?.region) {
            setOptions([]);
            vpcDetailsApi.mutate({
                sector: order.sector,
                department: order.department,
                accountId: order.landingZoneDetails.sharedNetworkAccountId,
                region: order.landingZoneDetails.region,
            });
        } else {
            setOptions([]);
        }
    }, [order?.sector, order?.department, order?.landingZoneDetails?.sharedNetworkAccountId, order?.landingZoneDetails?.region]);

    const handleOnSelectChange = (selected) => {
        if (selected) {
            setOrder({
                ...order,
                vpcName: selected?.value,
                vpcId: selected?.data?.vpcId,
            });
        }
    };

    const selectedOption = options.find((option) => option?.value === order?.vpcName || option?.data?.vpcId === order?.vpcId) || null;

    React.useEffect(() => {
        if (!order?.vpcName && order?.isTouched) setIsTouched(true);
    }, [order?.vpcName, order?.isTouched]);

    return (
        <Select
            key="vpcName"
            label={<InputLabel label="VPC Name" isRequired />}
            value={selectedOption}
            options={options}
            handleOnSelect={(value) => handleOnSelectChange(value)}
            disabled={options?.length === 1}
            isRequired={isTouched}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
        />
    );
};

export default React.memo(VpcName);
